import { render, staticRenderFns } from "./ProcesoCompraPlanoGeneral.vue?vue&type=template&id=56c09021"
import script from "./ProcesoCompraPlanoGeneral.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraPlanoGeneral.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompraPlanoGeneral.vue?vue&type=style&index=0&id=56c09021&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports